/*
 * File: cc-cell.component.ts                                                  *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 22nd December 2021 12:48:17                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Monday, 6th March 2023 10:07:23                              *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { fromEvent, Observable, Subscription } from 'rxjs';
import { CellService } from '../../../services/cell.service';
import { ProductService } from '../../../services/product.service';
import { Product } from '@nousmedis/cc-types';
import { CcGridTemplate } from 'app/modules/catalog-cloud/models/cc-grid-template.model';
import { CcGridTemplateCell } from 'app/modules/catalog-cloud/models/cc-grid-template-cell.model';

@Component({
  selector: 'app-cc-cell-template',
  templateUrl: './cc-cell-template.component.html',
  styleUrls: ['./cc-cell-template.component.scss'],
})
export class CcCellTemplateComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() cellId: number;
  @Input() grid: CcGridTemplate;
  @Input() locked: boolean;
  @Input() idCatalog: string;
  @Input() idFascicle: string;
  @Input() idPage: string;

  @Output() changeCell: EventEmitter<any> = new EventEmitter<any>();

  idRemoveImgBtn = '';
  cell: CcGridTemplateCell;
  subs = new Subscription();
  dragulaSelector: string;
  width = 0;
  height = 0;
  item: Product;
  itemId: string;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  cleanCell: Subscription;
  moveCell: Subscription;
  loading: boolean = true;

  viewItem: boolean = true;

  filled: boolean;

  constructor (
    private cellService: CellService,
    private productService: ProductService
  ) { }

  /**
   * Lectura incorrecta de las medidas.
   * Volver a probar en el grid para la correcta medida de la celda
   */

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getCellSize();
    }, 1);
  }

  ngOnInit(): void {
    this.cell = this.grid.cells[this.cellId];

    this.resizeObservable$ = fromEvent(window, 'resize');
    this.idRemoveImgBtn = 'remove-img-' + this.idPage + '-' + this.cellId;

    this.resizeSubscription$ = this.resizeObservable$.subscribe((evt) => {
      this.getCellSize();
    });
  }




  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.resizeSubscription$.unsubscribe();

  }

  getCellSize() {
    // this.height =
    //   (document.getElementById('page-' + this.idPage).offsetHeight /
    //     this.grid.rows) *
    //   this.cell.data.rowWidth;

    // this.width =
    //   (document.getElementById('page-' + this.idPage).offsetWidth /
    //     this.grid.columns) *
    //   this.cell.data.columnWith;
    
    const cells = this.grid.cells.map(c => c.data);
    this.changeCell.emit(cells);
  }



}
